import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { PersonGrid } from "./OnShiftToday";

export function OnShiftWithMe({ heading }) {
  const [d, setD] = useState(null);
  useEffect(() => { api("/web/on-shift-today").then(setD).catch(() => setD(null)); }, []);
  if (!d?.on_shift) return null;
  return (
    <section className="mb-10 fade-up" data-testid="on-shift-with-me">
      {heading}
      <div className="panel !p-3 sm:!p-5">
        <p className="text-sm text-slate-500 mb-4" data-testid="on-shift-with-me-info">Reparto {d.reparto} · il tuo orario <span className="font-semibold text-[var(--navy)]">{d.orario}</span></p>
        {d.colleghi.length === 0 ? <p className="text-sm text-slate-500" data-testid="on-shift-with-me-empty">Oggi nessun altro collega del reparto è di turno.</p> : <PersonGrid people={d.colleghi} prefix="colleague" />}
      </div>
    </section>
  );
}
